// extracted by mini-css-extract-plugin
module.exports = {"grid":"Decoding_grid__cq_Kp","item":"Decoding_item__RElon","imageItem":"Decoding_imageItem__DoqYe","heading":"Decoding_heading__C7KpK","subHeading":"Decoding_subHeading__Ob_fU"};